import { render } from "./OrderPaymentSuccessPage.vue?vue&type=template&id=5df24fc1&scoped=true&ts=true"
import script from "./OrderPaymentSuccessPage.vue?vue&type=script&lang=ts"
export * from "./OrderPaymentSuccessPage.vue?vue&type=script&lang=ts"

import "./OrderPaymentSuccessPage.vue?vue&type=style&index=0&id=5df24fc1&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df24fc1"]])

export default __exports__